declare global {
  interface Window {
    // set by Site Builder's frame-index.tsx only inside the editor iframe
    __IS_SB_EDITOR__?: boolean;
  }
}

export function checkEditorMode(): boolean {
  if (typeof window === 'undefined') return false;

  return !!window.__IS_SB_EDITOR__;
}
